import { Route } from "react-router-dom";
import RestrictedAccessPage from "./RestrictedAccessPage";

const routes = {
  key: "RESTRICTED_ACCESS",
  routes: ({ path, urlWithoutScope, restrictedAccessScope }) => {
    return [
      <Route
        key={"restricted-access"}
        path={path}
        element={
          <RestrictedAccessPage
            urlWithoutScope={urlWithoutScope}
            restrictedAccessScope={restrictedAccessScope}
          />
        }
      />,
    ];
  },
};
export default routes;
